import type { RedpenOpenResult } from '@shared/lib/redpenWidget';

export type SendFeedbackMessage = {
  type: 'warning' | 'error';
  title: string;
  text: string;
};

/**
 * What the side menu says after "Send feedback" is clicked (ZLAYT-1667).
 * Nothing when Redpen's form opened; otherwise a pointer to Redpen's own
 * Feedback tab, or why the feedback tool is not there.
 */
export function sendFeedbackMessage(
  result: RedpenOpenResult
): SendFeedbackMessage | null {
  if (result === 'opened') {
    return null;
  }
  if (result === 'tab') {
    return {
      type: 'warning',
      title: 'Send feedback',
      text: 'Click the Feedback tab on the right edge of the screen (now highlighted) to report a problem or an idea.',
    };
  }
  return {
    type: 'error',
    title: 'Feedback tool not loaded',
    text: 'The feedback tool has not loaded yet. Wait a few seconds or reload the page. If it still does not appear, a browser extension or network filter may be blocking redpen.ai.',
  };
}
